module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "GeminiLogo.5cbba47e.png";